import React from 'react';

const YoutubeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={35}
    height={25}
    viewBox="0 0 35 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.8112 1.25005C32.2805 1.64478 33.4428 2.80707 33.8376 4.27636C34.5612 6.9518 34.5832 12.5 34.5832 12.5C34.5832 12.5 34.5832 18.0702 33.8595 20.7237C33.4647 22.193 32.3025 23.3553 30.8332 23.7501C28.1797 24.4737 17.4998 24.4737 17.4998 24.4737C17.4998 24.4737 6.82001 24.4737 4.1665 23.7501C2.6972 23.3553 1.53493 22.193 1.14019 20.7237C0.416504 18.0483 0.416504 12.5 0.416504 12.5C0.416504 12.5 0.416504 6.9518 1.11826 4.2983C1.513 2.829 2.67528 1.66672 4.14457 1.27199C6.79808 0.548292 17.4779 0.526367 17.4779 0.526367C17.4779 0.526367 28.1577 0.526367 30.8112 1.25005ZM22.9384 12.5001L14.0788 17.6316V7.36847L22.9384 12.5001Z"
      fill="#0A3887"
    />
  </svg>
);

export default YoutubeIcon;
